import React from "react";

export default function MySQL_SIN() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_SIN</h1>
      <p>This is the MySQL_SIN component generated from the SQL JSON.</p>
    </div>
  );
}
